import { isCreditReportAccount } from 'utils/creditReportAccounts';
const getListOfflineAccounts = (data, without) => {
    const accounts = [];
    for (let index = 0; index < data.length; index += 1) {
        for (let x = 0; x < data[index].accounts.length; x += 1) {
            const account = { ...data[index].accounts[x] };
            if ((without &&
                account.provider !== 'MANUAL' &&
                !isCreditReportAccount(account)) ||
                (!without && account.provider === 'MANUAL'))
                accounts.push(account);
        }
    }
    return accounts;
};
export default getListOfflineAccounts;
